export const PERMISSION_KEYS = {
  all: ['permissions'] as const,
  index: () => [...PERMISSION_KEYS.all, 'index'] as const,
};
